import { createSelector } from '@ngrx/store'

export const getMobileSettingsState = createSelector(
  (state: any) => state.mobileSettings,
  (state: any) => state,
)
